import styled from 'styled-components';

import AnimatedLoader from '../AnimatedLoader/centred';
import OverlayStyles from './OverlayStyles';

export default styled(AnimatedLoader)`
  ${OverlayStyles}
`;



// WEBPACK FOOTER //
// ./app/components/Chart/StyledAnimatedLoader.js